import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import './EdisIncidentFormField.sass';

export const EdisIncidentFormField = ({ className, children }) => {
  const classes = classnames('form-field-wrapper', {
    [`${className}`]: !!className,
  });
  return <div className={classes}>{children}</div>;
};

EdisIncidentFormField.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

EdisIncidentFormField.defaultProps = {
  className: '',
};
